import { render, staticRenderFns } from "./sincobrador.vue?vue&type=template&id=3253398b&"
import script from "./sincobrador.vue?vue&type=script&lang=js&"
export * from "./sincobrador.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./sincobrador.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports